module.exports = __webpack_public_path__ + "static/media/textIcon.d5fdbc39.svg";